import Typography from '@/components/Typography';
import { TextStyles } from '@/constants';
import styled from 'styled-components';

export const EmailNotificationContainer = styled.div({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
});

export const EmailNotificationTitle = styled(Typography).attrs({
  variant: TextStyles['Heading 2'],
})(({ theme }) => ({
  color: theme.colors.highEmphasisBlack,
}));
